<template>
  <div>
    <el-card>
      <el-row :gutter="16" class="row-item">
        <el-col :span="6">
          {{ $t('storage::in-stock::instock_type') }}：
          <span>{{ order.stockTypeName }}</span>
        </el-col>
        <el-col :span="6">
          {{ $t('storage::in-stock::supplier') }}：
          <span>{{ order.supplierName }}</span>
        </el-col>
        <el-col :span="6">
          {{ $t('storage::in-stock::relate_num') }}：
          <span>{{ order.sourceNo }}</span>
        </el-col>
        <el-col :span="6">
          {{ $t('storage::in-stock::remark') }}：
          <span>{{ order.remark }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="16" class="row-item">
        <el-col :span="6">
          {{ $t('storage::in-stock::creator') }}：
          <span>{{ order.applicantditorName }}</span>
        </el-col>
        <el-col :span="6">
          {{ $t('storage::in-stock::create_time') }}：
          <span>{{ order.createTime }}</span>
        </el-col>
        <el-col :span="6">
          {{ $t('storage::in-stock::fullfillment_num') }}：
          <span>{{ order.fulfillmentNo }}</span>
        </el-col>
        <el-col :span="6">
          {{ $t('storage::in-stock::add_stock_no') }}：
          <span>{{ order.stockNo }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="16" class="row-item">
        <el-col :span="6">
          {{ $t('storage::in-stock::table_auditor') }}：
          <span>{{ order.auditorName }}</span>
        </el-col>
        <el-col :span="6">
          {{ $t('storage::in-stock::table_audit_time') }}：
          <span>{{ order.auditTime }}</span>
        </el-col>
        <el-col :span="6">
          {{ $t('storage::in-stock::third_bill_num') }}：
          <span>{{ order.thirdPartyNo }}</span>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 10px">
      <div style="display:flex;justify-content: space-between;margin-bottom:16px;">
        <div></div>
        <div>
          <span>SKU</span>
          <el-input v-model="searchValue" style="width:200px;margin-left:5px;">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
      </div>
      <z-table
        :columns="tableColumns"
        :data="searchList"
        :max-height="600"
        v-loading="loading"
        :pagination="false"
        class="prodinfo--table"
      >
        <template #skuId="{row}">
          <span>{{ row.skuId }}{{ row.skuProperty ? '-' + row.skuProperty : '' }}</span>
        </template>
        <template #spuName="{row}">
          <div class="prodinfo--table__imgTd">
            <el-popover placement="top-start" trigger="hover">
              <ZImg :src="row.img" style="width: 250px;height: 250px"></ZImg>
              <ZImg :src="row.img" style="width: 50px;height: 50px;margin-right:10px" slot="reference"></ZImg>
            </el-popover>
            <div>
              <div>{{ row.title }}</div>
              <div>{{ row.categoryName }}</div>
            </div>
          </div>
        </template>
        <template #qty="{row}">
          {{ $dataCheck(row.qty) }}
        </template>
        <template #totalPrice="{row}">
          {{ $dataCheck(row.totalPrice) }}
        </template>
      </z-table>
    </el-card>
  </div>
</template>

<script>
import { getStockOrderDetail } from '@/server/stock'
import { IN_STORAGE_ORDER_COLUMNS } from './config'
export default {
  data() {
    return {
      order: {
        supplierId: '',
        sourceNoType: 1,
        sourceNo: '',
        fulfillmentNo: '',
        operTime: '',
        type: 1,
        thirdPartyNo: '',
        value: '',
        remark: '',
        detailList: []
      },
      tableList: [],
      tableColumns: IN_STORAGE_ORDER_COLUMNS,
      tableData: [],
      loading: false,
      searchValue: ''
    }
  },
  mounted() {
    this.tableColumns = IN_STORAGE_ORDER_COLUMNS.slice(1)
    this.getDetail(this.$route.params.id)
  },
  computed: {
    searchList() {
      return this.tableList.filter(el => String(el.skuId).includes(this.searchValue))
    }
  },
  methods: {
    async getDetail(id) {
      this.loading = true
      const { data } = await getStockOrderDetail(id)
      if (data.code === this.$code) {
        this.order = data.data
        this.tableList = data.data.detailList || []
      }
      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep.input-with-select .el-select .el-input {
  width: 100px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.prodinfo--table {
  &__imgTd {
    display: flex;
    align-items: center;
    padding: 10px 0;
    img {
      width: 50px;
      height: 50px;
      margin-right: 10px;
    }
  }
  /deep/ .el-table td {
    padding: 0;
  }
  .tag-wrap {
    display: flex;
    align-items: center;
  }
}
.row-item + .row-item {
  margin-top: 10px;
}
</style>
